export default __webpack_public_path__ + "static/media/final-step3.30d24f0d.jpeg";